import React from 'react';

function Button() {
  return <div className="Button"></div>;
}

export default Button;
